import React, { useCallback, useMemo } from 'react';

import Icon from '../../../../Icon';
import { getSafeNormalRange } from '../../utils';
import { shouldShowRange } from '../utils/graphData';
import { useLabTestHistoryContext } from '../state/context';

import styles from './index.styl';

export const LabTestHistoryLegend = () => {
  const { data, formatMessage } = useLabTestHistoryContext();
  const isThereRange = useCallback(shouldShowRange(data), [data]);

  const { componentResultNormalRange = '', componentResultUnits = '' } =
    data[0] || '';

  const safeNormalRange = getSafeNormalRange(
    componentResultNormalRange,
    componentResultUnits,
  );

  const normalStateValue = useMemo(
    () => (componentResultNormalRange ? safeNormalRange : <span>&#8212;</span>),
    [componentResultNormalRange, safeNormalRange],
  );

  return (
    <div className={styles.wrapper}>
      <div className={styles.unit}>
        <Icon
          className={styles.icon}
          size={24}
          name="icon-graph-devices-line-point-black"
        />
        <div className={styles.textWrapper}>
          {formatMessage({ id: 'patient.healthboard.value' })}
        </div>
      </div>
      {isThereRange && (
        <div className={styles.unit}>
          <Icon
            className={styles.icon}
            size={24}
            name="icon-graph-health-record-point-green"
          />
          <div className={styles.textWrapper}>
            {`${formatMessage({ id: 'patient.healthboard.normalRange' })}: `}
            {normalStateValue}
          </div>
        </div>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/LabTestHistoryModal/LabTestHistoryLegend/index.jsx